import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star, Users, MapPin } from "lucide-react";

const COUNTIES = [
  "Maricopa County, AZ",
  "Harris County, TX",
  "Cook County, IL",
  "Miami-Dade County, FL",
  "Los Angeles County, CA",
  "Clark County, NV",
  "Wayne County, MI",
  "Cuyahoga County, OH",
  "Fulton County, GA",
  "Philadelphia County, PA",
  "Mecklenburg County, NC",
  "Bexar County, TX",
  "Orange County, FL",
  "King County, WA",
  "Salt Lake County, UT",
];

export default function SocialProofBar() {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % COUNTIES.length), 2600);
    return () => clearInterval(t);
  }, []);

  return (
    <section
      aria-label="Social proof"
      className="relative bg-[#0F172A] border-y border-[#FF008F]/20"
      data-testid="social-proof-bar"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 py-4 sm:py-5">
        <div className="flex flex-col md:flex-row items-center justify-center md:justify-between gap-3 md:gap-6 text-[#F7F5F0]">
          {/* Stars + headline */}
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-0.5" aria-label="5 out of 5 stars">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 sm:w-[18px] sm:h-[18px] fill-[#FFB800] text-[#FFB800]"
                />
              ))}
            </div>
            <p className="text-xs sm:text-sm tracking-wide">
              <span className="font-bold">Trusted by 500+ families</span>
              <span className="hidden sm:inline text-[#F7F5F0]/70"> across 48 states</span>
            </p>
          </div>

          {/* Divider (desktop) */}
          <div className="hidden md:block h-5 w-px bg-[#F7F5F0]/20" aria-hidden="true" />

          {/* Recovered count */}
          <div className="flex items-center gap-2 text-xs sm:text-sm" data-testid="social-proof-recovered">
            <Users className="w-4 h-4 text-[#FF008F]" />
            <span>
              <span className="font-bold">$8.2M+</span>
              <span className="text-[#F7F5F0]/70"> recovered for clients</span>
            </span>
          </div>

          {/* Divider (desktop) */}
          <div className="hidden md:block h-5 w-px bg-[#F7F5F0]/20" aria-hidden="true" />

          {/* Rotating county ticker */}
          <div className="flex items-center gap-2 text-xs sm:text-sm min-h-[20px]" data-testid="social-proof-ticker">
            <MapPin className="w-4 h-4 text-[#FF008F] shrink-0" />
            <span className="text-[#F7F5F0]/70 hidden sm:inline">Recent claim:</span>
            <span className="relative inline-block min-w-[180px] sm:min-w-[200px]">
              <AnimatePresence mode="wait">
                <motion.span
                  key={COUNTIES[idx]}
                  initial={{ opacity: 0, y: 6 }}
                  animate={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: -6 }}
                  transition={{ duration: 0.45, ease: "easeOut" }}
                  className="font-medium text-[#F7F5F0] block"
                >
                  {COUNTIES[idx]}
                </motion.span>
              </AnimatePresence>
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
